export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Cursor: { input: any; output: any; }
  Datetime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export type ActivePermission = {
  __typename?: 'ActivePermission';
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  environmentId?: Maybe<Scalars['UUID']['output']>;
  fromManagedService?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  serviceId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['UUID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  usageScope?: Maybe<PermissionUsageScope>;
  usedByManagedServiceOnly?: Maybe<Scalars['Boolean']['output']>;
  usedForDevelopment?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * A condition to be used against `ActivePermission` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ActivePermissionCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `fromManagedService` field. */
  fromManagedService?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `serviceId` field. */
  serviceId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `usageScope` field. */
  usageScope?: InputMaybe<PermissionUsageScope>;
  /** Checks for equality with the object’s `usedByManagedServiceOnly` field. */
  usedByManagedServiceOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `usedForDevelopment` field. */
  usedForDevelopment?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A filter to be used against `ActivePermission` object types. All fields are combined with a logical ‘and.’ */
export type ActivePermissionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ActivePermissionFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `fromManagedService` field. */
  fromManagedService?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ActivePermissionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ActivePermissionFilter>>;
  /** Filter by the object’s `serviceId` field. */
  serviceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `usageScope` field. */
  usageScope?: InputMaybe<PermissionUsageScopeFilter>;
  /** Filter by the object’s `usedByManagedServiceOnly` field. */
  usedByManagedServiceOnly?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `usedForDevelopment` field. */
  usedForDevelopment?: InputMaybe<BooleanFilter>;
};

/** A connection to a list of `ActivePermission` values. */
export type ActivePermissionsConnection = {
  __typename?: 'ActivePermissionsConnection';
  /** A list of edges which contains the `ActivePermission` and cursor to aid in pagination. */
  edges: Array<ActivePermissionsEdge>;
  /** A list of `ActivePermission` objects. */
  nodes: Array<ActivePermission>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ActivePermission` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ActivePermission` edge in the connection. */
export type ActivePermissionsEdge = {
  __typename?: 'ActivePermissionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ActivePermission` at the end of the edge. */
  node: ActivePermission;
};

/** Methods to use when ordering `ActivePermission`. */
export enum ActivePermissionsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  FromManagedServiceAsc = 'FROM_MANAGED_SERVICE_ASC',
  FromManagedServiceDesc = 'FROM_MANAGED_SERVICE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  ServiceIdAsc = 'SERVICE_ID_ASC',
  ServiceIdDesc = 'SERVICE_ID_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC',
  UsageScopeAsc = 'USAGE_SCOPE_ASC',
  UsageScopeDesc = 'USAGE_SCOPE_DESC',
  UsedByManagedServiceOnlyAsc = 'USED_BY_MANAGED_SERVICE_ONLY_ASC',
  UsedByManagedServiceOnlyDesc = 'USED_BY_MANAGED_SERVICE_ONLY_DESC',
  UsedForDevelopmentAsc = 'USED_FOR_DEVELOPMENT_ASC',
  UsedForDevelopmentDesc = 'USED_FOR_DEVELOPMENT_DESC'
}

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type BulkEditAsyncPayloadType = {
  __typename?: 'BulkEditAsyncPayloadType';
  filterMatchedIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type BulkEditAsyncUserAddInput = {
  userRoleAssignments?: InputMaybe<Array<InputMaybe<BulkEditAsyncUserAddUserRoleAssignmentInput>>>;
};

export type BulkEditAsyncUserAddUserRoleAssignmentInput = {
  userRoleId: Scalars['UUID']['input'];
};

export type BulkEditAsyncUserClearInput = {
  userRoleAssignments?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkEditAsyncUserRemoveInput = {
  userRoleAssignments?: InputMaybe<Array<InputMaybe<BulkEditAsyncUserRemoveUserRoleAssignmentInput>>>;
};

export type BulkEditAsyncUserRemoveUserRoleAssignmentInput = {
  userRoleId: Scalars['UUID']['input'];
};

export type BulkEditAsyncUserRoleAddInput = {
  userRoleParentAssignments?: InputMaybe<Array<InputMaybe<BulkEditAsyncUserRoleAddUserRoleParentAssignmentInput>>>;
  userRolePermissionAssignments?: InputMaybe<Array<InputMaybe<BulkEditAsyncUserRoleAddUserRolePermissionAssignmentInput>>>;
  userRoleTagAssignments?: InputMaybe<Array<InputMaybe<BulkEditAsyncUserRoleAddUserRoleTagAssignmentInput>>>;
};

export type BulkEditAsyncUserRoleAddUserRoleParentAssignmentInput = {
  userRoleId: Scalars['UUID']['input'];
};

export type BulkEditAsyncUserRoleAddUserRolePermissionAssignmentInput = {
  permissionId: Scalars['UUID']['input'];
};

export type BulkEditAsyncUserRoleAddUserRoleTagAssignmentInput = {
  tag: Scalars['String']['input'];
};

export type BulkEditAsyncUserRoleClearInput = {
  userRoleParentAssignments?: InputMaybe<Scalars['Boolean']['input']>;
  userRolePermissionAssignments?: InputMaybe<Scalars['Boolean']['input']>;
  userRoleTagAssignments?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkEditAsyncUserRoleRemoveInput = {
  userRoleParentAssignments?: InputMaybe<Array<InputMaybe<BulkEditAsyncUserRoleRemoveUserRoleParentAssignmentInput>>>;
  userRolePermissionAssignments?: InputMaybe<Array<InputMaybe<BulkEditAsyncUserRoleRemoveUserRolePermissionAssignmentInput>>>;
  userRoleTagAssignments?: InputMaybe<Array<InputMaybe<BulkEditAsyncUserRoleRemoveUserRoleTagAssignmentInput>>>;
};

export type BulkEditAsyncUserRoleRemoveUserRoleParentAssignmentInput = {
  userRoleId: Scalars['UUID']['input'];
};

export type BulkEditAsyncUserRoleRemoveUserRolePermissionAssignmentInput = {
  permissionId: Scalars['UUID']['input'];
};

export type BulkEditAsyncUserRoleRemoveUserRoleTagAssignmentInput = {
  tag: Scalars['String']['input'];
};

/** Bulk mutation payload type. */
export type BulkMutationUuidPayload = {
  __typename?: 'BulkMutationUuidPayload';
  affectedIds?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum ConflictResolution {
  OverwriteAll = 'OVERWRITE_ALL',
  OverwriteNonProtected = 'OVERWRITE_NON_PROTECTED',
  Skip = 'SKIP'
}

/** All input for the create `User` mutation. */
export type CreateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `User` to be created by this mutation. */
  user: UserInput;
};

/** The output of our create `User` mutation. */
export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was created by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our create `User` mutation. */
export type CreateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the create `UserRoleAssignment` mutation. */
export type CreateUserRoleAssignmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UserRoleAssignment` to be created by this mutation. */
  userRoleAssignment: UserRoleAssignmentInput;
};

/** The output of our create `UserRoleAssignment` mutation. */
export type CreateUserRoleAssignmentPayload = {
  __typename?: 'CreateUserRoleAssignmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserRoleAssignment`. */
  user?: Maybe<User>;
  /** Reads a single `UserRole` that is related to this `UserRoleAssignment`. */
  userRole?: Maybe<UserRole>;
  /** The `UserRoleAssignment` that was created by this mutation. */
  userRoleAssignment?: Maybe<UserRoleAssignment>;
  /** An edge for our `UserRoleAssignment`. May be used by Relay 1. */
  userRoleAssignmentEdge?: Maybe<UserRoleAssignmentsEdge>;
};


/** The output of our create `UserRoleAssignment` mutation. */
export type CreateUserRoleAssignmentPayloadUserRoleAssignmentEdgeArgs = {
  orderBy?: InputMaybe<Array<UserRoleAssignmentsOrderBy>>;
};

/** All input for the create `UserRole` mutation. */
export type CreateUserRoleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UserRole` to be created by this mutation. */
  userRole: UserRoleInput;
};

/** All input for the create `UserRoleParentAssignment` mutation. */
export type CreateUserRoleParentAssignmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UserRoleParentAssignment` to be created by this mutation. */
  userRoleParentAssignment: UserRoleParentAssignmentInput;
};

/** The output of our create `UserRoleParentAssignment` mutation. */
export type CreateUserRoleParentAssignmentPayload = {
  __typename?: 'CreateUserRoleParentAssignmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `UserRole` that is related to this `UserRoleParentAssignment`. */
  parentUserRole?: Maybe<UserRole>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserRoleParentAssignment` that was created by this mutation. */
  userRoleParentAssignment?: Maybe<UserRoleParentAssignment>;
  /** An edge for our `UserRoleParentAssignment`. May be used by Relay 1. */
  userRoleParentAssignmentEdge?: Maybe<UserRoleParentAssignmentsEdge>;
};


/** The output of our create `UserRoleParentAssignment` mutation. */
export type CreateUserRoleParentAssignmentPayloadUserRoleParentAssignmentEdgeArgs = {
  orderBy?: InputMaybe<Array<UserRoleParentAssignmentsOrderBy>>;
};

/** The output of our create `UserRole` mutation. */
export type CreateUserRolePayload = {
  __typename?: 'CreateUserRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserRole` that was created by this mutation. */
  userRole?: Maybe<UserRole>;
  /** An edge for our `UserRole`. May be used by Relay 1. */
  userRoleEdge?: Maybe<UserRolesEdge>;
};


/** The output of our create `UserRole` mutation. */
export type CreateUserRolePayloadUserRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
};

/** All input for the create `UserRolePermissionAssignment` mutation. */
export type CreateUserRolePermissionAssignmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UserRolePermissionAssignment` to be created by this mutation. */
  userRolePermissionAssignment: UserRolePermissionAssignmentInput;
};

/** The output of our create `UserRolePermissionAssignment` mutation. */
export type CreateUserRolePermissionAssignmentPayload = {
  __typename?: 'CreateUserRolePermissionAssignmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Permission` that is related to this `UserRolePermissionAssignment`. */
  permission?: Maybe<Permission>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UserRole` that is related to this `UserRolePermissionAssignment`. */
  userRole?: Maybe<UserRole>;
  /** The `UserRolePermissionAssignment` that was created by this mutation. */
  userRolePermissionAssignment?: Maybe<UserRolePermissionAssignment>;
  /** An edge for our `UserRolePermissionAssignment`. May be used by Relay 1. */
  userRolePermissionAssignmentEdge?: Maybe<UserRolePermissionAssignmentsEdge>;
};


/** The output of our create `UserRolePermissionAssignment` mutation. */
export type CreateUserRolePermissionAssignmentPayloadUserRolePermissionAssignmentEdgeArgs = {
  orderBy?: InputMaybe<Array<UserRolePermissionAssignmentsOrderBy>>;
};

/** All input for the create `UserRoleTagAssignment` mutation. */
export type CreateUserRoleTagAssignmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `UserRoleTagAssignment` to be created by this mutation. */
  userRoleTagAssignment: UserRoleTagAssignmentInput;
};

/** The output of our create `UserRoleTagAssignment` mutation. */
export type CreateUserRoleTagAssignmentPayload = {
  __typename?: 'CreateUserRoleTagAssignmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UserRole` that is related to this `UserRoleTagAssignment`. */
  userRole?: Maybe<UserRole>;
  /** The `UserRoleTagAssignment` that was created by this mutation. */
  userRoleTagAssignment?: Maybe<UserRoleTagAssignment>;
  /** An edge for our `UserRoleTagAssignment`. May be used by Relay 1. */
  userRoleTagAssignmentEdge?: Maybe<UserRoleTagAssignmentsEdge>;
};


/** The output of our create `UserRoleTagAssignment` mutation. */
export type CreateUserRoleTagAssignmentPayloadUserRoleTagAssignmentEdgeArgs = {
  orderBy?: InputMaybe<Array<UserRoleTagAssignmentsOrderBy>>;
};

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']['input']>>;
};

/** All input for the `deleteUser` mutation. */
export type DeleteUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `User` mutation. */
export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was deleted by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our delete `User` mutation. */
export type DeleteUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `deleteUserRoleAssignment` mutation. */
export type DeleteUserRoleAssignmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `UserRoleAssignment` mutation. */
export type DeleteUserRoleAssignmentPayload = {
  __typename?: 'DeleteUserRoleAssignmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserRoleAssignment`. */
  user?: Maybe<User>;
  /** Reads a single `UserRole` that is related to this `UserRoleAssignment`. */
  userRole?: Maybe<UserRole>;
  /** The `UserRoleAssignment` that was deleted by this mutation. */
  userRoleAssignment?: Maybe<UserRoleAssignment>;
  /** An edge for our `UserRoleAssignment`. May be used by Relay 1. */
  userRoleAssignmentEdge?: Maybe<UserRoleAssignmentsEdge>;
};


/** The output of our delete `UserRoleAssignment` mutation. */
export type DeleteUserRoleAssignmentPayloadUserRoleAssignmentEdgeArgs = {
  orderBy?: InputMaybe<Array<UserRoleAssignmentsOrderBy>>;
};

/** All input for the `deleteUserRole` mutation. */
export type DeleteUserRoleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** All input for the `deleteUserRoleParentAssignment` mutation. */
export type DeleteUserRoleParentAssignmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `UserRoleParentAssignment` mutation. */
export type DeleteUserRoleParentAssignmentPayload = {
  __typename?: 'DeleteUserRoleParentAssignmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `UserRole` that is related to this `UserRoleParentAssignment`. */
  parentUserRole?: Maybe<UserRole>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserRoleParentAssignment` that was deleted by this mutation. */
  userRoleParentAssignment?: Maybe<UserRoleParentAssignment>;
  /** An edge for our `UserRoleParentAssignment`. May be used by Relay 1. */
  userRoleParentAssignmentEdge?: Maybe<UserRoleParentAssignmentsEdge>;
};


/** The output of our delete `UserRoleParentAssignment` mutation. */
export type DeleteUserRoleParentAssignmentPayloadUserRoleParentAssignmentEdgeArgs = {
  orderBy?: InputMaybe<Array<UserRoleParentAssignmentsOrderBy>>;
};

/** The output of our delete `UserRole` mutation. */
export type DeleteUserRolePayload = {
  __typename?: 'DeleteUserRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserRole` that was deleted by this mutation. */
  userRole?: Maybe<UserRole>;
  /** An edge for our `UserRole`. May be used by Relay 1. */
  userRoleEdge?: Maybe<UserRolesEdge>;
};


/** The output of our delete `UserRole` mutation. */
export type DeleteUserRolePayloadUserRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
};

/** All input for the `deleteUserRolePermissionAssignment` mutation. */
export type DeleteUserRolePermissionAssignmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `UserRolePermissionAssignment` mutation. */
export type DeleteUserRolePermissionAssignmentPayload = {
  __typename?: 'DeleteUserRolePermissionAssignmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Permission` that is related to this `UserRolePermissionAssignment`. */
  permission?: Maybe<Permission>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UserRole` that is related to this `UserRolePermissionAssignment`. */
  userRole?: Maybe<UserRole>;
  /** The `UserRolePermissionAssignment` that was deleted by this mutation. */
  userRolePermissionAssignment?: Maybe<UserRolePermissionAssignment>;
  /** An edge for our `UserRolePermissionAssignment`. May be used by Relay 1. */
  userRolePermissionAssignmentEdge?: Maybe<UserRolePermissionAssignmentsEdge>;
};


/** The output of our delete `UserRolePermissionAssignment` mutation. */
export type DeleteUserRolePermissionAssignmentPayloadUserRolePermissionAssignmentEdgeArgs = {
  orderBy?: InputMaybe<Array<UserRolePermissionAssignmentsOrderBy>>;
};

/** All input for the `deleteUserRoleTagAssignment` mutation. */
export type DeleteUserRoleTagAssignmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['UUID']['input'];
  tag: Scalars['String']['input'];
  tenantId: Scalars['UUID']['input'];
  userRoleId: Scalars['UUID']['input'];
};

/** The output of our delete `UserRoleTagAssignment` mutation. */
export type DeleteUserRoleTagAssignmentPayload = {
  __typename?: 'DeleteUserRoleTagAssignmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `UserRole` that is related to this `UserRoleTagAssignment`. */
  userRole?: Maybe<UserRole>;
  /** The `UserRoleTagAssignment` that was deleted by this mutation. */
  userRoleTagAssignment?: Maybe<UserRoleTagAssignment>;
  /** An edge for our `UserRoleTagAssignment`. May be used by Relay 1. */
  userRoleTagAssignmentEdge?: Maybe<UserRoleTagAssignmentsEdge>;
};


/** The output of our delete `UserRoleTagAssignment` mutation. */
export type DeleteUserRoleTagAssignmentPayloadUserRoleTagAssignmentEdgeArgs = {
  orderBy?: InputMaybe<Array<UserRoleTagAssignmentsOrderBy>>;
};

/** Exposes all error codes and messages for errors that a service requests can throw. In some cases, messages that are actually thrown can be different, since they can include more details or a single code can used for different errors of the same type. */
export enum ErrorCodesEnum {
  /** Access Token has expired. */
  AccessTokenExpired = 'ACCESS_TOKEN_EXPIRED',
  /** Access Token is invalid */
  AccessTokenInvalid = 'ACCESS_TOKEN_INVALID',
  /** Access Token Lifetime must be greater than or equal to 30. */
  AccessTokenLifetimeInsufficient = 'ACCESS_TOKEN_LIFETIME_INSUFFICIENT',
  /** Access Token is not provided */
  AccessTokenRequired = 'ACCESS_TOKEN_REQUIRED',
  /** Access token verification failed */
  AccessTokenVerificationFailed = 'ACCESS_TOKEN_VERIFICATION_FAILED',
  /** An active signing key already exists for the application. */
  ActiveSigningKeyExists = 'ACTIVE_SIGNING_KEY_EXISTS',
  /** The assertion check for the identifier %s failed. */
  AssertionFailed = 'ASSERTION_FAILED',
  /** Authenticated End User not found. */
  AuthenticatedEndUserNotFound = 'AUTHENTICATED_END_USER_NOT_FOUND',
  /** Authenticated Management Subject not found. */
  AuthenticatedManagementSubjectNotFound = 'AUTHENTICATED_MANAGEMENT_SUBJECT_NOT_FOUND',
  /** A Permission Definition or an EndUserAuthorizationConfig was not found to be passed into Postgraphile build options. This is a development time issue. */
  AuthorizationOptionsMisconfigured = 'AUTHORIZATION_OPTIONS_MISCONFIGURED',
  /** Auth config is invalid. */
  AuthConfigInvalid = 'AUTH_CONFIG_INVALID',
  /** Permission synchronization is allowed for Service IDs that start with `ax-` only with Managed Service Accounts. */
  AxServicePermissionSyncNotAllowed = 'AX_SERVICE_PERMISSION_SYNC_NOT_ALLOWED',
  /** Cannot change the state while the service [%s] has a pending state change. No action was performed. */
  CannotChangeStateWhenPending = 'CANNOT_CHANGE_STATE_WHEN_PENDING',
  /** Cannot change the state for the service [%s] when it has a failed state change attempt, please retry the previous action. No action was performed. */
  CannotChangeStateWithError = 'CANNOT_CHANGE_STATE_WITH_ERROR',
  /** Service [%s] is a core-service and cannot be disabled. No action was performed. */
  CannotDisableCoreService = 'CANNOT_DISABLE_CORE_SERVICE',
  /** Unable to enable Tenant as there are currently no Tenant Administrators in active state. */
  CannotEnableTenant = 'CANNOT_ENABLE_TENANT',
  /** The Administrator role cannot be renamed or deleted. */
  CannotMutateAdminRole = 'CANNOT_MUTATE_ADMIN_ROLE',
  /** This is a system defined role and cannot be renamed, deleted, or have its protection status changed. */
  CannotMutateSystemRole = 'CANNOT_MUTATE_SYSTEM_ROLE',
  /** Client ID and Client Secret are required to enable the identity provider. */
  ClientIdSecretRequired = 'CLIENT_ID_SECRET_REQUIRED',
  /** Error updating service account client secret. */
  ClientSecretUpdateFailed = 'CLIENT_SECRET_UPDATE_FAILED',
  /** The service [%s] does not support the [%s] command. */
  CommandNotSupported = 'COMMAND_NOT_SUPPORTED',
  /** Contains invalid permissions. */
  ContainsInvalidPermissions = 'CONTAINS_INVALID_PERMISSIONS',
  /** Custom branding is not allowed for this identity provider. */
  CustomBrandingNotAllowed = 'CUSTOM_BRANDING_NOT_ALLOWED',
  /** customStepFunctionName missing in orchestration step. */
  CustomStepFunctionNameMissing = 'CUSTOM_STEP_FUNCTION_NAME_MISSING',
  /** An error occurred while checking for cyclic user roles. */
  CyclicRoleValidateError = 'CYCLIC_ROLE_VALIDATE_ERROR',
  /** A database operation has failed because of a lock timeout. */
  DatabaseLockTimeoutError = 'DATABASE_LOCK_TIMEOUT_ERROR',
  /** An authorization database error has occurred. The user might not have enough permissions. */
  DatabasePermissionsCheckFailed = 'DATABASE_PERMISSIONS_CHECK_FAILED',
  /** An expected and handled database constraint error has occurred. The actual message will have more information. */
  DatabaseValidationFailed = 'DATABASE_VALIDATION_FAILED',
  /** Error accessing database. */
  DbAccessError = 'DB_ACCESS_ERROR',
  /** A user with the same email address already exists. Please check if the email address is correct */
  EmailInUse = 'EMAIL_IN_USE',
  /** Environment [%s] is not enabled for use. */
  EnvironmentNotActive = 'ENVIRONMENT_NOT_ACTIVE',
  /** Environment [%s] not found. */
  EnvironmentNotFound = 'ENVIRONMENT_NOT_FOUND',
  /** The account is not activated. Please contact another Tenant Administrator or Axinom Support to activate the account. */
  EnvAdminAccountNotActive = 'ENV_ADMIN_ACCOUNT_NOT_ACTIVE',
  /** Either the account or the tenant is not enabled for usage. */
  EnvAdminOrTenantNotActive = 'ENV_ADMIN_OR_TENANT_NOT_ACTIVE',
  /** Cannot enable the environment when the initialization status is not [Completed]. */
  EnvInitializationNotCompleted = 'ENV_INITIALIZATION_NOT_COMPLETED',
  /** Error occurred generating a service account secret. */
  ErrorGeneratingServiceAccountSecret = 'ERROR_GENERATING_SERVICE_ACCOUNT_SECRET',
  /** An error occurred while attempting to retrieve token signing key details. */
  ErrorRetrievingSigningKeys = 'ERROR_RETRIEVING_SIGNING_KEYS',
  /** This is a wrapper error for the original unhandled error of unsupported type. */
  ErrorWrapper = 'ERROR_WRAPPER',
  /** A GraphQL validation error has occurred. Please make sure that the GraphQL request is made with correct syntax or parameters. */
  GraphqlValidationFailed = 'GRAPHQL_VALIDATION_FAILED',
  /** The Identity service is not accessible. Please contact Axinom support. */
  IdentityServiceNotAccessible = 'IDENTITY_SERVICE_NOT_ACCESSIBLE',
  /** IDP configuration does not exist. */
  IdpConfigDoesNotExist = 'IDP_CONFIG_DOES_NOT_EXIST',
  /** Built in IDP configuration is only available for Google IDP. */
  IdpConfigOnlyAvailableForGoogle = 'IDP_CONFIG_ONLY_AVAILABLE_FOR_GOOGLE',
  /** The value for initDefaults does not match its schema. */
  InitDefaultsSchemaMismatch = 'INIT_DEFAULTS_SCHEMA_MISMATCH',
  /** An unhandled and unexpected error has occurred. Please contact the service support. */
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  /** Invalid Client ID or Client Secret */
  InvalidClientIdSecret = 'INVALID_CLIENT_ID_SECRET',
  /** Invalid email or password. */
  InvalidCredentials = 'INVALID_CREDENTIALS',
  /** Email format is invalid. */
  InvalidEmailFormat = 'INVALID_EMAIL_FORMAT',
  /** Invalid email or tenant not enabled for usage. */
  InvalidEmailOrTenantInactive = 'INVALID_EMAIL_OR_TENANT_INACTIVE',
  /** Email Whitelist Pattern is not valid */
  InvalidEmailWhitelistPattern = 'INVALID_EMAIL_WHITELIST_PATTERN',
  /** Invalid Environment ID. */
  InvalidEnvironmentId = 'INVALID_ENVIRONMENT_ID',
  /** Unrecognized state change was attempted and an error was logged. */
  InvalidEnvironmentState = 'INVALID_ENVIRONMENT_STATE',
  /** Error occurred while trying to fetch signing keys from the JWKS endpoint for the Tenant/Environment/Application. */
  JwksError = 'JWKS_ERROR',
  /** Passed JWT is not a Mosaic End-User Token. Cannot be verified. */
  JwtIsNotMosaicToken = 'JWT_IS_NOT_MOSAIC_TOKEN',
  /** Please disable the tenant before deactivating the last active Tenant Administrator. */
  LastTenantAdminActiveTenantDeactivate = 'LAST_TENANT_ADMIN_ACTIVE_TENANT_DEACTIVATE',
  /** Please disable the tenant before deleting the last active Tenant Administrator. */
  LastTenantAdminActiveTenantDelete = 'LAST_TENANT_ADMIN_ACTIVE_TENANT_DELETE',
  /** IDP logout can only be enabled for custom identity providers. */
  LogoutFromIdpNotAllowed = 'LOGOUT_FROM_IDP_NOT_ALLOWED',
  /** Malformed access token received */
  MalformedToken = 'MALFORMED_TOKEN',
  /** Service [%s] is already disabled for this environment. No action was performed. */
  ManagedServiceAlreadyDisabled = 'MANAGED_SERVICE_ALREADY_DISABLED',
  /** Service [%s] is already enabled for this environment. No action was performed. */
  ManagedServiceAlreadyEnabled = 'MANAGED_SERVICE_ALREADY_ENABLED',
  /** Managed service [%s] not found in environment [%s]. */
  ManagedServiceNotFound = 'MANAGED_SERVICE_NOT_FOUND',
  /** The token is not an Authenticated End-User */
  NotAuthenticatedEndUser = 'NOT_AUTHENTICATED_END_USER',
  /** The object is not a AuthenticatedManagementSubject */
  NotAuthenticatedManagementSubject = 'NOT_AUTHENTICATED_MANAGEMENT_SUBJECT',
  /** The object is not a AuthenticatedRequest */
  NotAuthenticatedRequest = 'NOT_AUTHENTICATED_REQUEST',
  /** A caught error is not an AxiosError. */
  NotAxiosError = 'NOT_AXIOS_ERROR',
  /** The token is not an End-User Application */
  NotEndUserApplication = 'NOT_END_USER_APPLICATION',
  /** The object is not an EndUserAuthenticationContext */
  NotEndUserAuthenticationContext = 'NOT_END_USER_AUTHENTICATION_CONTEXT',
  /** The object is not a GenericAuthenticatedSubject */
  NotGenericAuthenticatedSubject = 'NOT_GENERIC_AUTHENTICATED_SUBJECT',
  /** The object is not a ManagementAuthenticationContext */
  NotManagementAuthenticationContext = 'NOT_MANAGEMENT_AUTHENTICATION_CONTEXT',
  /** No active token signing keys found for the environment [%s]. */
  NoActiveSigningKey = 'NO_ACTIVE_SIGNING_KEY',
  /** Token does not contain an email. */
  NoEmailInToken = 'NO_EMAIL_IN_TOKEN',
  /** A caught error does not contain an error code. */
  NoErrorCodeFound = 'NO_ERROR_CODE_FOUND',
  /** The %s is missing required properties: %s. */
  ObjectIsMissingProperties = 'OBJECT_IS_MISSING_PROPERTIES',
  /** The user [%s] can only use Single Sign-On mode for tenant [%s]. */
  OnlySsoAllowed = 'ONLY_SSO_ALLOWED',
  /** The environment's first orchestration step must have message-params. */
  OrchestrationParamsMissing = 'ORCHESTRATION_PARAMS_MISSING',
  /** Dynamic orchestration step resolution failed. */
  OrchestrationStepResolutionFailed = 'ORCHESTRATION_STEP_RESOLUTION_FAILED',
  /** Error generating the password. */
  PasswordGeneartionError = 'PASSWORD_GENEARTION_ERROR',
  /** The new password does not meet the minimum policy requirements. */
  PasswordPolicyMismatch = 'PASSWORD_POLICY_MISMATCH',
  /** Payload not found in pg-notification. */
  PayloadNotFound = 'PAYLOAD_NOT_FOUND',
  /** Error occurred trying to purge permissions. */
  PermissionPurgeError = 'PERMISSION_PURGE_ERROR',
  /** Purging permissions for Service IDs that start with `ax-` is not allowed. */
  PermissionPurgeNotAllowedForAxServices = 'PERMISSION_PURGE_NOT_ALLOWED_FOR_AX_SERVICES',
  /** Error occurred trying to synchronize permissions. */
  PermissionSyncError = 'PERMISSION_SYNC_ERROR',
  /** Permissions with the `usedByManagedServiceOnly` flag set can only be synchronized by a Managed Service. */
  PermissionUsedByManagedServiceOnly = 'PERMISSION_USED_BY_MANAGED_SERVICE_ONLY',
  /** Root Environment not found. */
  RootEnvironmentNotFound = 'ROOT_ENVIRONMENT_NOT_FOUND',
  /** Root Tenant not found. */
  RootTenantNotFound = 'ROOT_TENANT_NOT_FOUND',
  /** An error occurred while exporting Service Accounts. */
  ServiceAccountExportError = 'SERVICE_ACCOUNT_EXPORT_ERROR',
  /** An error occurred while importing Service Accounts. */
  ServiceAccountImportError = 'SERVICE_ACCOUNT_IMPORT_ERROR',
  /** Service Account does not exist. */
  ServiceAccountNotExists = 'SERVICE_ACCOUNT_NOT_EXISTS',
  /** This service account is protected and cannot be modified or deleted. Remove the protection first. */
  ServiceAccountProtected = 'SERVICE_ACCOUNT_PROTECTED',
  /** The service-id is required for service-state-change-events. */
  ServiceIdNotFound = 'SERVICE_ID_NOT_FOUND',
  /** Could not find a matching signing key to verify the access token. The signing key used to create the token may have been revoked or the Tenant/Environment/Application configuration is erroneous. */
  SigningKeyNotFound = 'SIGNING_KEY_NOT_FOUND',
  /** An error occurred while rotating signing keys. */
  SigningKeyRotateError = 'SIGNING_KEY_ROTATE_ERROR',
  /** We encountered an error while validating your SSO token with the Axinom Portal. Please try again in a few seconds. If the problem persists, please contact Axinom Support. */
  SsoTokenValidationError = 'SSO_TOKEN_VALIDATION_ERROR',
  /** An application startup error has occurred. The actual message will have more information. */
  StartupError = 'STARTUP_ERROR',
  /** Step function [%s] is not found in the mapping. */
  StepFunctionNotFoundInMapping = 'STEP_FUNCTION_NOT_FOUND_IN_MAPPING',
  /** Orchestration error. Step function [%s] not found. */
  StepFuncNotFound = 'STEP_FUNC_NOT_FOUND',
  /** User is authenticated, but subject information was not found. Please contact Axinom Support. */
  SubjectNotFound = 'SUBJECT_NOT_FOUND',
  /** Could not complete authentication. targetTenantId is missing. */
  TargetTenantMissing = 'TARGET_TENANT_MISSING',
  /** The linked Environment Administration Portal account [%s] is not active. Please contact Axinom Support. */
  TenantAdminNotActive = 'TENANT_ADMIN_NOT_ACTIVE',
  /** Tenant Admin does not exist. */
  TenantAdminNotExists = 'TENANT_ADMIN_NOT_EXISTS',
  /** Tenant Admin [%s] not found. */
  TenantAdminNotFound = 'TENANT_ADMIN_NOT_FOUND',
  /** The Environment Administration Portal is not linked to your Axinom Portal account [%s]. Please contact Axinom Support. */
  TenantAdminNotLinkedToAxPortal = 'TENANT_ADMIN_NOT_LINKED_TO_AX_PORTAL',
  /** The tenant [%s] is not active. Please contact Axinom Support. */
  TenantNotActive = 'TENANT_NOT_ACTIVE',
  /** Tenant does not exist. */
  TenantNotExists = 'TENANT_NOT_EXISTS',
  /** Tenant [%s] not found. */
  TenantNotFound = 'TENANT_NOT_FOUND',
  /** The subject has no permissions. */
  Unauthorized = 'UNAUTHORIZED',
  /** Unexpected null or undefined value received. */
  UnexpectedNullUndefined = 'UNEXPECTED_NULL_UNDEFINED',
  /** Unhandled Axios error. */
  UnhandledAxiosError = 'UNHANDLED_AXIOS_ERROR',
  /** An unhandled database-related error has occurred. Please contact the service support. */
  UnhandledDatabaseError = 'UNHANDLED_DATABASE_ERROR',
  /** An unhandled error has occurred. Please contact the service support. */
  UnhandledError = 'UNHANDLED_ERROR',
  /** Attempt to create or update an element failed, as it would have resulted in a duplicate element. */
  UniqueConstraintError = 'UNIQUE_CONSTRAINT_ERROR',
  /** Environment created with an unsupported template [%s]. */
  UnsupportedTemplate = 'UNSUPPORTED_TEMPLATE',
  /** User is not authorized to access the operation. */
  UserNotAuthorized = 'USER_NOT_AUTHORIZED',
  /** User not found. */
  UserNotFound = 'USER_NOT_FOUND',
  /** An error occurred while exporting User Roles. */
  UserRoleExportError = 'USER_ROLE_EXPORT_ERROR',
  /** An error occurred while importing User Roles. */
  UserRoleImportError = 'USER_ROLE_IMPORT_ERROR',
  /** User Role not found. */
  UserRoleNotFound = 'USER_ROLE_NOT_FOUND',
  /** This user role is protected and cannot be modified or deleted. Remove the protection first. */
  UserRoleProtected = 'USER_ROLE_PROTECTED',
  /** The User service is not accessible. Please contact Axinom support. */
  UserServiceNotAccessible = 'USER_SERVICE_NOT_ACCESSIBLE',
  /** The userProfile query only supports Management Users. (User Tokens with SubjectType: UserAccount). */
  UserTypeNotSupported = 'USER_TYPE_NOT_SUPPORTED',
  /** The %s is not an object. */
  ValueIsNotObject = 'VALUE_IS_NOT_OBJECT',
  /** Websocket not found in ExtendedGraphQLContext. This is a development time issue. A reference to the websocket must be included in Postgraphile build options. */
  WebsocketNotFound = 'WEBSOCKET_NOT_FOUND'
}

export type ExportedPermissionRef = {
  __typename?: 'ExportedPermissionRef';
  name: Scalars['String']['output'];
  serviceId: Scalars['String']['output'];
};

export type ExportedUserRole = {
  __typename?: 'ExportedUserRole';
  description?: Maybe<Scalars['String']['output']>;
  isProtected: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parentRoles: Array<Scalars['String']['output']>;
  permissions: Array<ExportedPermissionRef>;
  tags: Array<Scalars['String']['output']>;
};

/** A `String` edge in the connection. */
export type GetUserRoleTagValueEdge = {
  __typename?: 'GetUserRoleTagValueEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `String` at the end of the edge. */
  node?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of `String` values. */
export type GetUserRoleTagValuesConnection = {
  __typename?: 'GetUserRoleTagValuesConnection';
  /** A list of edges which contains the `String` and cursor to aid in pagination. */
  edges: Array<GetUserRoleTagValueEdge>;
  /** A list of `String` objects. */
  nodes: Array<Maybe<Scalars['String']['output']>>;
  /** The count of *all* `String` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

export type ImportEntityResult = {
  __typename?: 'ImportEntityResult';
  created: Array<Scalars['String']['output']>;
  skipped: Array<Scalars['String']['output']>;
  updated: Array<Scalars['String']['output']>;
};

export type ImportError = {
  __typename?: 'ImportError';
  detail?: Maybe<Scalars['String']['output']>;
  entityName: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  errorCode: ImportErrorCode;
};

export enum ImportErrorCode {
  CyclicRoleDetected = 'CYCLIC_ROLE_DETECTED',
  InvalidPayload = 'INVALID_PAYLOAD',
  ParentRoleNotFound = 'PARENT_ROLE_NOT_FOUND',
  PayloadTooLarge = 'PAYLOAD_TOO_LARGE',
  PermissionNotFound = 'PERMISSION_NOT_FOUND'
}

export type ImportPermissionRefInput = {
  name: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
};

export type ImportUserRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isProtected?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  parentRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  permissions?: InputMaybe<Array<ImportPermissionRefInput>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ImportUserRolesInput = {
  userRoles: Array<ImportUserRoleInput>;
  version: Scalars['String']['input'];
};

export type ImportUserRolesPayload = {
  __typename?: 'ImportUserRolesPayload';
  errors: Array<ImportError>;
  userRoles?: Maybe<ImportEntityResult>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  bulkEditUserRolesAsync?: Maybe<BulkEditAsyncPayloadType>;
  bulkEditUsersAsync?: Maybe<BulkEditAsyncPayloadType>;
  /** Creates a single `User`. */
  createUser?: Maybe<CreateUserPayload>;
  /** Creates a single `UserRole`. */
  createUserRole?: Maybe<CreateUserRolePayload>;
  /** Creates a single `UserRoleAssignment`. */
  createUserRoleAssignment?: Maybe<CreateUserRoleAssignmentPayload>;
  /** Creates a single `UserRoleParentAssignment`. */
  createUserRoleParentAssignment?: Maybe<CreateUserRoleParentAssignmentPayload>;
  /** Creates a single `UserRolePermissionAssignment`. */
  createUserRolePermissionAssignment?: Maybe<CreateUserRolePermissionAssignmentPayload>;
  /** Creates a single `UserRoleTagAssignment`. */
  createUserRoleTagAssignment?: Maybe<CreateUserRoleTagAssignmentPayload>;
  /** Deletes a single `User` using a unique key. */
  deleteUser?: Maybe<DeleteUserPayload>;
  /** Deletes a single `UserRole` using a unique key. */
  deleteUserRole?: Maybe<DeleteUserRolePayload>;
  /** Deletes a single `UserRoleAssignment` using a unique key. */
  deleteUserRoleAssignment?: Maybe<DeleteUserRoleAssignmentPayload>;
  /** Deletes a single `UserRoleParentAssignment` using a unique key. */
  deleteUserRoleParentAssignment?: Maybe<DeleteUserRoleParentAssignmentPayload>;
  /** Deletes a single `UserRolePermissionAssignment` using a unique key. */
  deleteUserRolePermissionAssignment?: Maybe<DeleteUserRolePermissionAssignmentPayload>;
  /** Deletes a single `UserRoleTagAssignment` using a unique key. */
  deleteUserRoleTagAssignment?: Maybe<DeleteUserRoleTagAssignmentPayload>;
  deleteUserRoles?: Maybe<BulkMutationUuidPayload>;
  deleteUsers?: Maybe<BulkMutationUuidPayload>;
  /**
   * Exports User Roles matching the given filter, including their permissions,
   * tags, and the full parent-role hierarchy
   */
  exportUserRoles: UserRolesExportPayload;
  /**
   * Imports User Roles previously exported by `exportUserRoles`. If any
   * validation errors are found (missing permissions/parent roles, cyclic
   * role hierarchies, or an invalid payload), nothing is written and the
   * errors are returned instead.
   */
  importUserRoles: ImportUserRolesPayload;
  /** Purges permissions for a given Service ID. */
  purgePermissions?: Maybe<PurgePermissionsPayload>;
  /** Adds a custom mutation to revoke refresh tokens */
  revokeRefreshToken: RevokeRefreshTokenPayload;
  /** Protects or unprotects a user role by adding/removing its row in the protected user role registry */
  setUserRoleProtection: UserRole;
  /** Synchronizes permissions from other services. */
  synchronizePermissions?: Maybe<SynchronizePermissionsPayload>;
  /** Updates a single `User` using a unique key and a patch. */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Updates a single `UserRole` using a unique key and a patch. */
  updateUserRole?: Maybe<UpdateUserRolePayload>;
  /**
   * Validate if a role that's being assigned to another role as a parent has a cyclic dependency or not.
   * If there is a cyclic dependency, the mutation returns false - indicating the validation failed.
   * If there is no cyclic dependency, the mutation returns true - indicating the validation passed.
   */
  validateCyclicUserRole: Scalars['Boolean']['output'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationBulkEditUserRolesAsyncArgs = {
  filter?: InputMaybe<UserRoleFilter>;
  relatedEntitiesToAdd?: InputMaybe<BulkEditAsyncUserRoleAddInput>;
  relatedEntitiesToClear?: InputMaybe<BulkEditAsyncUserRoleClearInput>;
  relatedEntitiesToRemove?: InputMaybe<BulkEditAsyncUserRoleRemoveInput>;
  set?: InputMaybe<UserRolePatch>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationBulkEditUsersAsyncArgs = {
  filter?: InputMaybe<UserFilter>;
  relatedEntitiesToAdd?: InputMaybe<BulkEditAsyncUserAddInput>;
  relatedEntitiesToClear?: InputMaybe<BulkEditAsyncUserClearInput>;
  relatedEntitiesToRemove?: InputMaybe<BulkEditAsyncUserRemoveInput>;
  set?: InputMaybe<UserPatch>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserRoleArgs = {
  input: CreateUserRoleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserRoleAssignmentArgs = {
  input: CreateUserRoleAssignmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserRoleParentAssignmentArgs = {
  input: CreateUserRoleParentAssignmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserRolePermissionAssignmentArgs = {
  input: CreateUserRolePermissionAssignmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserRoleTagAssignmentArgs = {
  input: CreateUserRoleTagAssignmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserRoleArgs = {
  input: DeleteUserRoleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserRoleAssignmentArgs = {
  input: DeleteUserRoleAssignmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserRoleParentAssignmentArgs = {
  input: DeleteUserRoleParentAssignmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserRolePermissionAssignmentArgs = {
  input: DeleteUserRolePermissionAssignmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserRoleTagAssignmentArgs = {
  input: DeleteUserRoleTagAssignmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserRolesArgs = {
  filter?: InputMaybe<UserRoleFilter>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUsersArgs = {
  filter?: InputMaybe<UserFilter>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationExportUserRolesArgs = {
  filter?: InputMaybe<UserRoleFilter>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationImportUserRolesArgs = {
  conflictResolution: ConflictResolution;
  input: ImportUserRolesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPurgePermissionsArgs = {
  input: PurgePermissionsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRevokeRefreshTokenArgs = {
  userId: Scalars['UUID']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetUserRoleProtectionArgs = {
  input: SetUserRoleProtectionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSynchronizePermissionsArgs = {
  input: SynchronizePermissionsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserRoleArgs = {
  input: UpdateUserRoleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationValidateCyclicUserRoleArgs = {
  input?: InputMaybe<ValidateCyclicUserRoleInput>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

export type Permission = {
  __typename?: 'Permission';
  createdAt: Scalars['Datetime']['output'];
  createdBy: Scalars['String']['output'];
  environmentId: Scalars['UUID']['output'];
  fromManagedService: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  serviceId: Scalars['String']['output'];
  tenantId: Scalars['UUID']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
  updatedBy: Scalars['String']['output'];
  usageScope: PermissionUsageScope;
  usedByManagedServiceOnly: Scalars['Boolean']['output'];
  usedForDevelopment: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `UserRolePermissionAssignment`. */
  userRolePermissionAssignments: UserRolePermissionAssignmentsConnection;
};


export type PermissionUserRolePermissionAssignmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserRolePermissionAssignmentCondition>;
  filter?: InputMaybe<UserRolePermissionAssignmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserRolePermissionAssignmentsOrderBy>>;
};

/**
 * A condition to be used against `Permission` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type PermissionCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `fromManagedService` field. */
  fromManagedService?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `serviceId` field. */
  serviceId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `usageScope` field. */
  usageScope?: InputMaybe<PermissionUsageScope>;
  /** Checks for equality with the object’s `usedByManagedServiceOnly` field. */
  usedByManagedServiceOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `usedForDevelopment` field. */
  usedForDevelopment?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A filter to be used against `Permission` object types. All fields are combined with a logical ‘and.’ */
export type PermissionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PermissionFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `fromManagedService` field. */
  fromManagedService?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PermissionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PermissionFilter>>;
  /** Filter by the object’s `serviceId` field. */
  serviceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `usageScope` field. */
  usageScope?: InputMaybe<PermissionUsageScopeFilter>;
  /** Filter by the object’s `usedByManagedServiceOnly` field. */
  usedByManagedServiceOnly?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `usedForDevelopment` field. */
  usedForDevelopment?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `userRolePermissionAssignments` relation. */
  userRolePermissionAssignments?: InputMaybe<PermissionToManyUserRolePermissionAssignmentFilter>;
  /** Some related `userRolePermissionAssignments` exist. */
  userRolePermissionAssignmentsExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A filter to be used against many `UserRolePermissionAssignment` object types. All fields are combined with a logical ‘and.’ */
export type PermissionToManyUserRolePermissionAssignmentFilter = {
  /** Every related `UserRolePermissionAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserRolePermissionAssignmentFilter>;
  /** No related `UserRolePermissionAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserRolePermissionAssignmentFilter>;
  /** Some related `UserRolePermissionAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserRolePermissionAssignmentFilter>;
};

export enum PermissionUsageScope {
  Any = 'ANY',
  Service = 'SERVICE'
}

/** A filter to be used against PermissionUsageScope fields. All fields are combined with a logical ‘and.’ */
export type PermissionUsageScopeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PermissionUsageScope>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PermissionUsageScope>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PermissionUsageScope>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PermissionUsageScope>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PermissionUsageScope>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PermissionUsageScope>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PermissionUsageScope>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PermissionUsageScope>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PermissionUsageScope>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PermissionUsageScope>>;
};

/** A connection to a list of `Permission` values. */
export type PermissionsConnection = {
  __typename?: 'PermissionsConnection';
  /** A list of edges which contains the `Permission` and cursor to aid in pagination. */
  edges: Array<PermissionsEdge>;
  /** A list of `Permission` objects. */
  nodes: Array<Permission>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Permission` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Permission` edge in the connection. */
export type PermissionsEdge = {
  __typename?: 'PermissionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Permission` at the end of the edge. */
  node: Permission;
};

/** Methods to use when ordering `Permission`. */
export enum PermissionsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  FromManagedServiceAsc = 'FROM_MANAGED_SERVICE_ASC',
  FromManagedServiceDesc = 'FROM_MANAGED_SERVICE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ServiceIdAsc = 'SERVICE_ID_ASC',
  ServiceIdDesc = 'SERVICE_ID_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC',
  UsageScopeAsc = 'USAGE_SCOPE_ASC',
  UsageScopeDesc = 'USAGE_SCOPE_DESC',
  UsedByManagedServiceOnlyAsc = 'USED_BY_MANAGED_SERVICE_ONLY_ASC',
  UsedByManagedServiceOnlyDesc = 'USED_BY_MANAGED_SERVICE_ONLY_DESC',
  UsedForDevelopmentAsc = 'USED_FOR_DEVELOPMENT_ASC',
  UsedForDevelopmentDesc = 'USED_FOR_DEVELOPMENT_DESC'
}

export type PurgePermissionsInput = {
  serviceId: Scalars['String']['input'];
};

export type PurgePermissionsPayload = {
  __typename?: 'PurgePermissionsPayload';
  purged: Array<Maybe<Scalars['String']['output']>>;
};

/** The root query type which gives access points into the data universe. */
export type Query = {
  __typename?: 'Query';
  /** Reads and enables pagination through a set of `ActivePermission`. */
  activePermissions?: Maybe<ActivePermissionsConnection>;
  getUserRoleTagValues?: Maybe<GetUserRoleTagValuesConnection>;
  permission?: Maybe<Permission>;
  /** Reads and enables pagination through a set of `Permission`. */
  permissions?: Maybe<PermissionsConnection>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  user?: Maybe<User>;
  /** Returns User Profile info along with assigned roles. */
  userProfile: UserProfilePayload;
  userRole?: Maybe<UserRole>;
  /** Reads and enables pagination through a set of `UserRoleInheritedPermission`. */
  userRoleAllPermissionAssignments?: Maybe<UserRoleInheritedPermissionsConnection>;
  userRoleAssignment?: Maybe<UserRoleAssignment>;
  /** Reads and enables pagination through a set of `UserRoleAssignment`. */
  userRoleAssignments?: Maybe<UserRoleAssignmentsConnection>;
  userRoleParentAssignment?: Maybe<UserRoleParentAssignment>;
  /** Reads and enables pagination through a set of `UserRoleParentAssignment`. */
  userRoleParentAssignments?: Maybe<UserRoleParentAssignmentsConnection>;
  userRolePermissionAssignment?: Maybe<UserRolePermissionAssignment>;
  /** Reads and enables pagination through a set of `UserRolePermissionAssignment`. */
  userRolePermissionAssignments?: Maybe<UserRolePermissionAssignmentsConnection>;
  userRoleTagAssignment?: Maybe<UserRoleTagAssignment>;
  /** Reads and enables pagination through a set of `UserRoleTagAssignment`. */
  userRoleTagAssignments?: Maybe<UserRoleTagAssignmentsConnection>;
  /** Reads and enables pagination through a set of `UserRole`. */
  userRoles?: Maybe<UserRolesConnection>;
  /** Reads and enables pagination through a set of `User`. */
  users?: Maybe<UsersConnection>;
  /** Reads and enables pagination through a set of `User`. */
  usersWithUserRoleFilter?: Maybe<UsersConnection>;
};


/** The root query type which gives access points into the data universe. */
export type QueryActivePermissionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActivePermissionCondition>;
  filter?: InputMaybe<ActivePermissionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivePermissionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetUserRoleTagValuesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  exclusionList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filter?: InputMaybe<StringFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPermissionArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPermissionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PermissionCondition>;
  filter?: InputMaybe<PermissionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PermissionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserRoleArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserRoleAllPermissionAssignmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<UserRoleInheritedPermissionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  userRoleId?: InputMaybe<Scalars['UUID']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserRoleAssignmentArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserRoleAssignmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserRoleAssignmentCondition>;
  filter?: InputMaybe<UserRoleAssignmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserRoleAssignmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserRoleParentAssignmentArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserRoleParentAssignmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserRoleParentAssignmentCondition>;
  filter?: InputMaybe<UserRoleParentAssignmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserRoleParentAssignmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserRolePermissionAssignmentArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserRolePermissionAssignmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserRolePermissionAssignmentCondition>;
  filter?: InputMaybe<UserRolePermissionAssignmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserRolePermissionAssignmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserRoleTagAssignmentArgs = {
  environmentId: Scalars['UUID']['input'];
  tag: Scalars['String']['input'];
  tenantId: Scalars['UUID']['input'];
  userRoleId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserRoleTagAssignmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserRoleTagAssignmentCondition>;
  filter?: InputMaybe<UserRoleTagAssignmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserRoleTagAssignmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserRoleCondition>;
  filter?: InputMaybe<UserRoleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUsersWithUserRoleFilterArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  excludeRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludeRolesIncludeInherited?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeRoles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  includeRolesIncludeInherited?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

export type RevokeRefreshTokenPayload = {
  __typename?: 'RevokeRefreshTokenPayload';
  revokedRefreshTokenCount: Scalars['Int']['output'];
};

export type SetUserRoleProtectionInput = {
  id: Scalars['UUID']['input'];
  isProtected: Scalars['Boolean']['input'];
};

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']['input']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']['input']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']['input']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against String List fields. All fields are combined with a logical ‘and.’ */
export type StringListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type Subscription = {
  __typename?: 'Subscription';
  /** Triggered when a user mutated: */
  userMutated?: Maybe<UserMutatedSubscriptionPayload>;
  /** Triggered when a user role mutated: */
  userRoleMutated?: Maybe<UserRoleMutatedSubscriptionPayload>;
};

export type SynchronizePermissionsInput = {
  permissions: Array<InputMaybe<Scalars['JSON']['input']>>;
  serviceId: Scalars['String']['input'];
};

export type SynchronizePermissionsPayload = {
  __typename?: 'SynchronizePermissionsPayload';
  added?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  removed?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** A filter to be used against UUID fields. All fields are combined with a logical ‘and.’ */
export type UuidFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['UUID']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['UUID']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** All input for the `updateUser` mutation. */
export type UpdateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `User` being updated. */
  patch: UserPatch;
};

/** The output of our update `User` mutation. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was updated by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our update `User` mutation. */
export type UpdateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `updateUserRole` mutation. */
export type UpdateUserRoleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `UserRole` being updated. */
  patch: UserRolePatch;
};

/** The output of our update `UserRole` mutation. */
export type UpdateUserRolePayload = {
  __typename?: 'UpdateUserRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserRole` that was updated by this mutation. */
  userRole?: Maybe<UserRole>;
  /** An edge for our `UserRole`. May be used by Relay 1. */
  userRoleEdge?: Maybe<UserRolesEdge>;
};


/** The output of our update `UserRole` mutation. */
export type UpdateUserRolePayloadUserRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
};

export type User = {
  __typename?: 'User';
  createdAt: Scalars['Datetime']['output'];
  createdBy: Scalars['String']['output'];
  email: Scalars['String']['output'];
  environmentId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  profilePictureUrl?: Maybe<Scalars['String']['output']>;
  status: UserStatus;
  tenantId: Scalars['UUID']['output'];
  updatedAt: Scalars['Datetime']['output'];
  updatedBy: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `UserRoleAssignment`. */
  userRoleAssignments: UserRoleAssignmentsConnection;
};


export type UserUserRoleAssignmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserRoleAssignmentCondition>;
  filter?: InputMaybe<UserRoleAssignmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserRoleAssignmentsOrderBy>>;
};

/** A condition to be used against `User` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type UserCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `profilePictureUrl` field. */
  profilePictureUrl?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<UserStatus>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `User` object types. All fields are combined with a logical ‘and.’ */
export type UserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserFilter>>;
  /** Filter by the object’s `profilePictureUrl` field. */
  profilePictureUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<UserStatusFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userRoleAssignments` relation. */
  userRoleAssignments?: InputMaybe<UserToManyUserRoleAssignmentFilter>;
  /** Some related `userRoleAssignments` exist. */
  userRoleAssignmentsExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An input for mutations affecting `User` */
export type UserInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  profilePictureUrl?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatus>;
};

export enum UserMutatedEventKey {
  UserChanged = 'USER_CHANGED',
  UserCreated = 'USER_CREATED',
  UserDeleted = 'USER_DELETED'
}

export type UserMutatedSubscriptionPayload = {
  __typename?: 'UserMutatedSubscriptionPayload';
  eventKey?: Maybe<UserMutatedEventKey>;
  id: Scalars['UUID']['output'];
  user?: Maybe<User>;
};

/** Represents an update to a `User`. Fields that are set will be updated. */
export type UserPatch = {
  status?: InputMaybe<UserStatus>;
};

export type UserProfilePayload = {
  __typename?: 'UserProfilePayload';
  email: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  profilePictureUrl?: Maybe<Scalars['String']['output']>;
  status: UserStatus;
  updatedAt: Scalars['Datetime']['output'];
  updatedBy: Scalars['String']['output'];
  userRoles: Array<UserRoleInfo>;
};

export type UserRole = {
  __typename?: 'UserRole';
  createdAt: Scalars['Datetime']['output'];
  createdBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  environmentId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  isProtected?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  tenantId: Scalars['UUID']['output'];
  updatedAt: Scalars['Datetime']['output'];
  updatedBy: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `UserRoleAssignment`. */
  userRoleAssignments: UserRoleAssignmentsConnection;
  /** Reads and enables pagination through a set of `UserRoleParentAssignment`. */
  userRoleParentAssignments: UserRoleParentAssignmentsConnection;
  /** Reads and enables pagination through a set of `UserRolePermissionAssignment`. */
  userRolePermissionAssignments: UserRolePermissionAssignmentsConnection;
  /** Reads and enables pagination through a set of `UserRoleTagAssignment`. */
  userRoleTagAssignments: UserRoleTagAssignmentsConnection;
};


export type UserRoleUserRoleAssignmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserRoleAssignmentCondition>;
  filter?: InputMaybe<UserRoleAssignmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserRoleAssignmentsOrderBy>>;
};


export type UserRoleUserRoleParentAssignmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserRoleParentAssignmentCondition>;
  filter?: InputMaybe<UserRoleParentAssignmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserRoleParentAssignmentsOrderBy>>;
};


export type UserRoleUserRolePermissionAssignmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserRolePermissionAssignmentCondition>;
  filter?: InputMaybe<UserRolePermissionAssignmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserRolePermissionAssignmentsOrderBy>>;
};


export type UserRoleUserRoleTagAssignmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<UserRoleTagAssignmentCondition>;
  filter?: InputMaybe<UserRoleTagAssignmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserRoleTagAssignmentsOrderBy>>;
};

export type UserRoleAssignment = {
  __typename?: 'UserRoleAssignment';
  createdAt: Scalars['Datetime']['output'];
  createdBy: Scalars['String']['output'];
  environmentId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  tenantId: Scalars['UUID']['output'];
  updatedAt: Scalars['Datetime']['output'];
  updatedBy: Scalars['String']['output'];
  /** Reads a single `User` that is related to this `UserRoleAssignment`. */
  user?: Maybe<User>;
  userId: Scalars['UUID']['output'];
  /** Reads a single `UserRole` that is related to this `UserRoleAssignment`. */
  userRole?: Maybe<UserRole>;
  userRoleId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `UserRoleAssignment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserRoleAssignmentCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `userRoleId` field. */
  userRoleId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `UserRoleAssignment` object types. All fields are combined with a logical ‘and.’ */
export type UserRoleAssignmentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserRoleAssignmentFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserRoleAssignmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserRoleAssignmentFilter>>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `userRole` relation. */
  userRole?: InputMaybe<UserRoleFilter>;
  /** Filter by the object’s `userRoleId` field. */
  userRoleId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `UserRoleAssignment` */
export type UserRoleAssignmentInput = {
  userId: Scalars['UUID']['input'];
  userRoleId: Scalars['UUID']['input'];
};

/** A connection to a list of `UserRoleAssignment` values. */
export type UserRoleAssignmentsConnection = {
  __typename?: 'UserRoleAssignmentsConnection';
  /** A list of edges which contains the `UserRoleAssignment` and cursor to aid in pagination. */
  edges: Array<UserRoleAssignmentsEdge>;
  /** A list of `UserRoleAssignment` objects. */
  nodes: Array<UserRoleAssignment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserRoleAssignment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UserRoleAssignment` edge in the connection. */
export type UserRoleAssignmentsEdge = {
  __typename?: 'UserRoleAssignmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserRoleAssignment` at the end of the edge. */
  node: UserRoleAssignment;
};

/** Methods to use when ordering `UserRoleAssignment`. */
export enum UserRoleAssignmentsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  UserRoleIdAsc = 'USER_ROLE_ID_ASC',
  UserRoleIdDesc = 'USER_ROLE_ID_DESC'
}

/**
 * A condition to be used against `UserRole` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UserRoleCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `UserRole` object types. All fields are combined with a logical ‘and.’ */
export type UserRoleFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserRoleFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isProtected` field. */
  isProtected?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserRoleFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserRoleFilter>>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userRoleAssignments` relation. */
  userRoleAssignments?: InputMaybe<UserRoleToManyUserRoleAssignmentFilter>;
  /** Some related `userRoleAssignments` exist. */
  userRoleAssignmentsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userRoleParentAssignments` relation. */
  userRoleParentAssignments?: InputMaybe<UserRoleToManyUserRoleParentAssignmentFilter>;
  /** Some related `userRoleParentAssignments` exist. */
  userRoleParentAssignmentsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userRolePermissionAssignments` relation. */
  userRolePermissionAssignments?: InputMaybe<UserRoleToManyUserRolePermissionAssignmentFilter>;
  /** Some related `userRolePermissionAssignments` exist. */
  userRolePermissionAssignmentsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `userRoleTagAssignments` relation. */
  userRoleTagAssignments?: InputMaybe<UserRoleToManyUserRoleTagAssignmentFilter>;
  /** Some related `userRoleTagAssignments` exist. */
  userRoleTagAssignmentsExist?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserRoleInfo = {
  __typename?: 'UserRoleInfo';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

export type UserRoleInheritedPermission = {
  __typename?: 'UserRoleInheritedPermission';
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  environmentId?: Maybe<Scalars['UUID']['output']>;
  fromManagedService?: Maybe<Scalars['Boolean']['output']>;
  isInherited?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentUserRoleIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  parentUserRoleNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  permissionAssignmentId?: Maybe<Scalars['UUID']['output']>;
  permissionId?: Maybe<Scalars['UUID']['output']>;
  serviceId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['UUID']['output']>;
  userRoleId?: Maybe<Scalars['UUID']['output']>;
};

/** A filter to be used against `UserRoleInheritedPermission` object types. All fields are combined with a logical ‘and.’ */
export type UserRoleInheritedPermissionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserRoleInheritedPermissionFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `fromManagedService` field. */
  fromManagedService?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isInherited` field. */
  isInherited?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserRoleInheritedPermissionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserRoleInheritedPermissionFilter>>;
  /** Filter by the object’s `parentUserRoleIds` field. */
  parentUserRoleIds?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `parentUserRoleNames` field. */
  parentUserRoleNames?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `permissionAssignmentId` field. */
  permissionAssignmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `permissionId` field. */
  permissionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `serviceId` field. */
  serviceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `userRoleId` field. */
  userRoleId?: InputMaybe<UuidFilter>;
};

/** A connection to a list of `UserRoleInheritedPermission` values. */
export type UserRoleInheritedPermissionsConnection = {
  __typename?: 'UserRoleInheritedPermissionsConnection';
  /** A list of edges which contains the `UserRoleInheritedPermission` and cursor to aid in pagination. */
  edges: Array<UserRoleInheritedPermissionsEdge>;
  /** A list of `UserRoleInheritedPermission` objects. */
  nodes: Array<UserRoleInheritedPermission>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserRoleInheritedPermission` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UserRoleInheritedPermission` edge in the connection. */
export type UserRoleInheritedPermissionsEdge = {
  __typename?: 'UserRoleInheritedPermissionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserRoleInheritedPermission` at the end of the edge. */
  node: UserRoleInheritedPermission;
};

/** An input for mutations affecting `UserRole` */
export type UserRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export enum UserRoleMutatedEventKey {
  UserRoleChanged = 'USER_ROLE_CHANGED',
  UserRoleCreated = 'USER_ROLE_CREATED',
  UserRoleDeleted = 'USER_ROLE_DELETED'
}

export type UserRoleMutatedSubscriptionPayload = {
  __typename?: 'UserRoleMutatedSubscriptionPayload';
  eventKey?: Maybe<UserRoleMutatedEventKey>;
  id: Scalars['UUID']['output'];
  userRole?: Maybe<UserRole>;
};

export type UserRoleParentAssignment = {
  __typename?: 'UserRoleParentAssignment';
  createdAt: Scalars['Datetime']['output'];
  createdBy: Scalars['String']['output'];
  environmentId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  /** Reads a single `UserRole` that is related to this `UserRoleParentAssignment`. */
  parentUserRole?: Maybe<UserRole>;
  parentUserRoleId: Scalars['UUID']['output'];
  tenantId: Scalars['UUID']['output'];
  updatedAt: Scalars['Datetime']['output'];
  updatedBy: Scalars['String']['output'];
  userRoleId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `UserRoleParentAssignment` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type UserRoleParentAssignmentCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `parentUserRoleId` field. */
  parentUserRoleId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userRoleId` field. */
  userRoleId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `UserRoleParentAssignment` object types. All fields are combined with a logical ‘and.’ */
export type UserRoleParentAssignmentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserRoleParentAssignmentFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserRoleParentAssignmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserRoleParentAssignmentFilter>>;
  /** Filter by the object’s `parentUserRole` relation. */
  parentUserRole?: InputMaybe<UserRoleFilter>;
  /** Filter by the object’s `parentUserRoleId` field. */
  parentUserRoleId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userRoleId` field. */
  userRoleId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `UserRoleParentAssignment` */
export type UserRoleParentAssignmentInput = {
  parentUserRoleId: Scalars['UUID']['input'];
  userRoleId: Scalars['UUID']['input'];
};

/** A connection to a list of `UserRoleParentAssignment` values. */
export type UserRoleParentAssignmentsConnection = {
  __typename?: 'UserRoleParentAssignmentsConnection';
  /** A list of edges which contains the `UserRoleParentAssignment` and cursor to aid in pagination. */
  edges: Array<UserRoleParentAssignmentsEdge>;
  /** A list of `UserRoleParentAssignment` objects. */
  nodes: Array<UserRoleParentAssignment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserRoleParentAssignment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UserRoleParentAssignment` edge in the connection. */
export type UserRoleParentAssignmentsEdge = {
  __typename?: 'UserRoleParentAssignmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserRoleParentAssignment` at the end of the edge. */
  node: UserRoleParentAssignment;
};

/** Methods to use when ordering `UserRoleParentAssignment`. */
export enum UserRoleParentAssignmentsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  ParentUserRoleIdAsc = 'PARENT_USER_ROLE_ID_ASC',
  ParentUserRoleIdDesc = 'PARENT_USER_ROLE_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC',
  UserRoleIdAsc = 'USER_ROLE_ID_ASC',
  UserRoleIdDesc = 'USER_ROLE_ID_DESC'
}

/** Represents an update to a `UserRole`. Fields that are set will be updated. */
export type UserRolePatch = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UserRolePermissionAssignment = {
  __typename?: 'UserRolePermissionAssignment';
  createdAt: Scalars['Datetime']['output'];
  createdBy: Scalars['String']['output'];
  environmentId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  /** Reads a single `Permission` that is related to this `UserRolePermissionAssignment`. */
  permission?: Maybe<Permission>;
  permissionId: Scalars['UUID']['output'];
  tenantId: Scalars['UUID']['output'];
  updatedAt: Scalars['Datetime']['output'];
  updatedBy: Scalars['String']['output'];
  /** Reads a single `UserRole` that is related to this `UserRolePermissionAssignment`. */
  userRole?: Maybe<UserRole>;
  userRoleId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `UserRolePermissionAssignment` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type UserRolePermissionAssignmentCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `permissionId` field. */
  permissionId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userRoleId` field. */
  userRoleId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `UserRolePermissionAssignment` object types. All fields are combined with a logical ‘and.’ */
export type UserRolePermissionAssignmentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserRolePermissionAssignmentFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserRolePermissionAssignmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserRolePermissionAssignmentFilter>>;
  /** Filter by the object’s `permission` relation. */
  permission?: InputMaybe<PermissionFilter>;
  /** Filter by the object’s `permissionId` field. */
  permissionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userRole` relation. */
  userRole?: InputMaybe<UserRoleFilter>;
  /** Filter by the object’s `userRoleId` field. */
  userRoleId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `UserRolePermissionAssignment` */
export type UserRolePermissionAssignmentInput = {
  permissionId: Scalars['UUID']['input'];
  userRoleId: Scalars['UUID']['input'];
};

/** A connection to a list of `UserRolePermissionAssignment` values. */
export type UserRolePermissionAssignmentsConnection = {
  __typename?: 'UserRolePermissionAssignmentsConnection';
  /** A list of edges which contains the `UserRolePermissionAssignment` and cursor to aid in pagination. */
  edges: Array<UserRolePermissionAssignmentsEdge>;
  /** A list of `UserRolePermissionAssignment` objects. */
  nodes: Array<UserRolePermissionAssignment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserRolePermissionAssignment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UserRolePermissionAssignment` edge in the connection. */
export type UserRolePermissionAssignmentsEdge = {
  __typename?: 'UserRolePermissionAssignmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserRolePermissionAssignment` at the end of the edge. */
  node: UserRolePermissionAssignment;
};

/** Methods to use when ordering `UserRolePermissionAssignment`. */
export enum UserRolePermissionAssignmentsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PermissionIdAsc = 'PERMISSION_ID_ASC',
  PermissionIdDesc = 'PERMISSION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC',
  UserRoleIdAsc = 'USER_ROLE_ID_ASC',
  UserRoleIdDesc = 'USER_ROLE_ID_DESC'
}

export type UserRoleTagAssignment = {
  __typename?: 'UserRoleTagAssignment';
  createdAt: Scalars['Datetime']['output'];
  createdBy: Scalars['String']['output'];
  environmentId: Scalars['UUID']['output'];
  tag: Scalars['String']['output'];
  tenantId: Scalars['UUID']['output'];
  updatedAt: Scalars['Datetime']['output'];
  updatedBy: Scalars['String']['output'];
  /** Reads a single `UserRole` that is related to this `UserRoleTagAssignment`. */
  userRole?: Maybe<UserRole>;
  userRoleId: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `UserRoleTagAssignment` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type UserRoleTagAssignmentCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdBy` field. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `tag` field. */
  tag?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `userRoleId` field. */
  userRoleId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `UserRoleTagAssignment` object types. All fields are combined with a logical ‘and.’ */
export type UserRoleTagAssignmentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserRoleTagAssignmentFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` field. */
  createdBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserRoleTagAssignmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserRoleTagAssignmentFilter>>;
  /** Filter by the object’s `tag` field. */
  tag?: InputMaybe<StringFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedBy` field. */
  updatedBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userRole` relation. */
  userRole?: InputMaybe<UserRoleFilter>;
  /** Filter by the object’s `userRoleId` field. */
  userRoleId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `UserRoleTagAssignment` */
export type UserRoleTagAssignmentInput = {
  tag: Scalars['String']['input'];
  userRoleId: Scalars['UUID']['input'];
};

/** A connection to a list of `UserRoleTagAssignment` values. */
export type UserRoleTagAssignmentsConnection = {
  __typename?: 'UserRoleTagAssignmentsConnection';
  /** A list of edges which contains the `UserRoleTagAssignment` and cursor to aid in pagination. */
  edges: Array<UserRoleTagAssignmentsEdge>;
  /** A list of `UserRoleTagAssignment` objects. */
  nodes: Array<UserRoleTagAssignment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserRoleTagAssignment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UserRoleTagAssignment` edge in the connection. */
export type UserRoleTagAssignmentsEdge = {
  __typename?: 'UserRoleTagAssignmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserRoleTagAssignment` at the end of the edge. */
  node: UserRoleTagAssignment;
};

/** Methods to use when ordering `UserRoleTagAssignment`. */
export enum UserRoleTagAssignmentsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TagAsc = 'TAG_ASC',
  TagDesc = 'TAG_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC',
  UserRoleIdAsc = 'USER_ROLE_ID_ASC',
  UserRoleIdDesc = 'USER_ROLE_ID_DESC'
}

/** A filter to be used against many `UserRoleAssignment` object types. All fields are combined with a logical ‘and.’ */
export type UserRoleToManyUserRoleAssignmentFilter = {
  /** Every related `UserRoleAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserRoleAssignmentFilter>;
  /** No related `UserRoleAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserRoleAssignmentFilter>;
  /** Some related `UserRoleAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserRoleAssignmentFilter>;
};

/** A filter to be used against many `UserRoleParentAssignment` object types. All fields are combined with a logical ‘and.’ */
export type UserRoleToManyUserRoleParentAssignmentFilter = {
  /** Every related `UserRoleParentAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserRoleParentAssignmentFilter>;
  /** No related `UserRoleParentAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserRoleParentAssignmentFilter>;
  /** Some related `UserRoleParentAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserRoleParentAssignmentFilter>;
};

/** A filter to be used against many `UserRolePermissionAssignment` object types. All fields are combined with a logical ‘and.’ */
export type UserRoleToManyUserRolePermissionAssignmentFilter = {
  /** Every related `UserRolePermissionAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserRolePermissionAssignmentFilter>;
  /** No related `UserRolePermissionAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserRolePermissionAssignmentFilter>;
  /** Some related `UserRolePermissionAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserRolePermissionAssignmentFilter>;
};

/** A filter to be used against many `UserRoleTagAssignment` object types. All fields are combined with a logical ‘and.’ */
export type UserRoleToManyUserRoleTagAssignmentFilter = {
  /** Every related `UserRoleTagAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserRoleTagAssignmentFilter>;
  /** No related `UserRoleTagAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserRoleTagAssignmentFilter>;
  /** Some related `UserRoleTagAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserRoleTagAssignmentFilter>;
};

/** A connection to a list of `UserRole` values. */
export type UserRolesConnection = {
  __typename?: 'UserRolesConnection';
  /** A list of edges which contains the `UserRole` and cursor to aid in pagination. */
  edges: Array<UserRolesEdge>;
  /** A list of `UserRole` objects. */
  nodes: Array<UserRole>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserRole` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `UserRole` edge in the connection. */
export type UserRolesEdge = {
  __typename?: 'UserRolesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `UserRole` at the end of the edge. */
  node: UserRole;
};

export type UserRolesExportPayload = {
  __typename?: 'UserRolesExportPayload';
  exportedAt: Scalars['Datetime']['output'];
  userRoles: Array<ExportedUserRole>;
  version: Scalars['String']['output'];
};

/** Methods to use when ordering `UserRole`. */
export enum UserRolesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC'
}

export enum UserStatus {
  /** Active */
  Active = 'ACTIVE',
  /** Blocked */
  Blocked = 'BLOCKED'
}

/** A filter to be used against UserStatus fields. All fields are combined with a logical ‘and.’ */
export type UserStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UserStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UserStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UserStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UserStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<UserStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<UserStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UserStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UserStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UserStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UserStatus>>;
};

/** A filter to be used against many `UserRoleAssignment` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserRoleAssignmentFilter = {
  /** Every related `UserRoleAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserRoleAssignmentFilter>;
  /** No related `UserRoleAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserRoleAssignmentFilter>;
  /** Some related `UserRoleAssignment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserRoleAssignmentFilter>;
};

/** A connection to a list of `User` values. */
export type UsersConnection = {
  __typename?: 'UsersConnection';
  /** A list of edges which contains the `User` and cursor to aid in pagination. */
  edges: Array<UsersEdge>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `User` edge in the connection. */
export type UsersEdge = {
  __typename?: 'UsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `User` at the end of the edge. */
  node: User;
};

/** Methods to use when ordering `User`. */
export enum UsersOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByAsc = 'CREATED_BY_ASC',
  CreatedByDesc = 'CREATED_BY_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProfilePictureUrlAsc = 'PROFILE_PICTURE_URL_ASC',
  ProfilePictureUrlDesc = 'PROFILE_PICTURE_URL_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UpdatedByAsc = 'UPDATED_BY_ASC',
  UpdatedByDesc = 'UPDATED_BY_DESC'
}

export type ValidateCyclicUserRoleInput = {
  baseUserRole: Scalars['UUID']['input'];
  parentUserRole: Scalars['UUID']['input'];
};
